/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAttachAdd = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M5.536 20.678a7 7 0 0 1 0-9.9l5.656-5.657a5 5 0 0 1 7.072 7.071l-5.657 5.657a3 3 0 1 1-4.243-4.242l4.243-4.243 1.414 1.414-4.243 4.243a1 1 0 1 0 1.414 1.414l5.657-5.657a3 3 0 1 0-4.242-4.242L6.95 12.192a5 5 0 0 0 7.07 7.072l7.072-7.072 1.414 1.415-7.071 7.07a7 7 0 0 1-9.9 0zM3 3V0h2v3h3v2H5v3H3V5H0V3z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAttachAdd as AttachAdd };
